import { render, staticRenderFns } from "./bsdwz.vue?vue&type=template&id=d4603a06&scoped=true&"
import script from "./bsdwz.vue?vue&type=script&lang=js&"
export * from "./bsdwz.vue?vue&type=script&lang=js&"
import style0 from "./bsdwz.vue?vue&type=style&index=0&id=d4603a06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4603a06",
  null
  
)

export default component.exports